<template>
  <div class="wrap-collabsible">
    <input :id="uniqueId + 'check'" :for="uniqueId" class="toggle" type="checkbox" :aria-label="uniqueId" />
    <label :id="uniqueId" class="lbl-toggle">{{ props.label }}</label>
    <div class="collapsible-content">
      <div class="content-inner">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  label: {
    type: String,
    default: ''
  }
})

const uniqueId = `collapsible-${Math.random().toString(36).slice(2, 11)}`;
</script>

<style>
/* input[type='checkbox'] {
  display: none;
} */

.wrap-collabsible {
  margin: 1.2rem 0;
}

.lbl-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Arial, sans-serif;
  font-size: 16px;
  padding: 24px 16px;
  color: #4F4F4F;
  cursor: pointer;
  transition: all 0.25s ease-out;
  border-bottom: 1px solid #F1F2F5;
  background: #FFF;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.lbl-toggle:hover {
  color: #333333;
}

.lbl-toggle::before {
  content: ' ';
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url('../../assets/iconLineV.png');
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: .7rem;
  transition: transform .2s ease-out;
  order: 1;
}

.toggle:checked+.lbl-toggle::before {
  transform: rotate(-180deg);
}

.toggle:checked+.lbl-toggle::after {
  transform: rotate(-90deg);
}

.collapsible-content {
  max-height: 0px;
  overflow: hidden;
  transition: max-height .4s ease-in-out;
}

.toggle:checked+.lbl-toggle+.collapsible-content {
  max-height: 350px;
}

.toggle:checked+.lbl-toggle {
  background: #F1F2F5;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.collapsible-content .content-inner {
  background: #F1F2F5;
  border-bottom: 1px solid #F1F2F5;
  padding: .5rem 1rem;
}

.collapsible-content p {
  margin-bottom: 0;
}
</style>